import React, { useState } from 'react'
import { Button, Popup } from 'semantic-ui-react'
import { AllowPermission } from 'shared/components/AllowPermission'
import { CrownBadge } from 'components/ProFeatureLabel'
import UpgradePlanModalContainer from 'components/UpgradePlanModal/container'
import constants from 'config/constants'

/**
 *
 * @param {object} props
 * @param {React.Component} props.trigger
 * @param {string} props.title
 * @param {string | React.Component} props.description
 * @param {string} props.learnMoreLink
 */
export function UpgradeToProFeatureTooltip({
  trigger: Component,
  title,
  description,
  learnMoreLink,
}) {
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)

  function openUpgradeModal() {
    setIsPopupOpen(false)
    setIsUpgradeModalOpen(true)
  }

  return (
    <React.Fragment>
      <Popup
        basic
        hoverable
        open={isPopupOpen}
        onOpen={() => setIsPopupOpen(true)}
        onClose={() => setIsPopupOpen(false)}
        className="wide"
        mouseEnterDelay={500}
        trigger={Component}
        style={{ minWidth: 380 }}
      >
        <h3 className="ui dividing header" style={{ paddingBottom: '10px', paddingTop: '4px' }}>
          {title} <CrownBadge />
        </h3>
        <p>{description}</p>
        <a
          className="ui primary button mr3"
          href={learnMoreLink}
          target="_blank"
          rel="noreferrer"
          onClick={preventEventPropagation}
        >
          <i className="book far icon" />
          Learn more
        </a>
        <AllowPermission permission={constants.permissions.manageBillingInformation}>
          <Button onClick={openUpgradeModal}>Upgrade plan</Button>
        </AllowPermission>
      </Popup>
      <UpgradePlanModalContainer
        isOpen={isUpgradeModalOpen}
        onClose={() => setIsUpgradeModalOpen(false)}
      />
    </React.Fragment>
  )
}

function preventEventPropagation(e) {
  e.stopPropagation()
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ProLabelTooltip/index.js